import React, { useEffect } from "react";
import { StickerInterface } from "../../../../store/sticker_maker/stickersSlice";

import { Button, Form } from "antd";
import FileDropzone from "../../../../componets/FileDropzone";

interface propsInterface {
  params?: StickerInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='image' label='Image' preview={params?.image_url} />
      </div>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
